import withStyles from 'react-jss';

import MenuButton from './component';
import styles from './styles';

export default withStyles(styles)(MenuButton);
